import {AccessDevicesTitle, IconChipDepartment, IconCustomAccess} from "../../../../../../../components/buttons/IconButtons";
import React, { useState } from "react";
import AssignedTabResource from "../../../../../../../components/ResourceAssignment/SubComponents/AssignedTabResource";
import { TabPanelApp } from "../../../../../../../components/ResourceAssignment/Functionality/TabPanelApp";
import { SHIFT_RESOURCE } from "../Model/Models";
import { AssignedShiftResourceApp } from "../Functionality/AssignedShiftResourceApp";
import CustomTooltip from "../../../../../../../components/CustomTooltip";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */

/**
 * Read-only assigned list for one shift resource (devices / departments /
 * users) inside the list detail expand. Owns its own tab state and renders the
 * server assigned page through AssignedTabResource in readOnly mode (no
 * checkbox, no deletion).
 *
 * @param {Object} props
 * @param {string} props.resource - SHIFT_RESOURCE type.
 * @param {number|string} props.id - Shift id.
 * @returns {JSX.Element}
 */
const RenderAssignedSection = ({ resource, id, title, Icon }) => {
    const [selected, setSelected] = useState([]);
    const [selectForDelete, setSelectForDelete] = useState([]);

    const {
        t,
        results, setResults,
        setBodyForExport,
        searchElement, setSearchElement,
        setSearch,
        setSimpleSearch,
        modified, setModified,
        triggerDelete, setTriggerDelete,
        isAllChecked, setIsAllChecked,
    } = TabPanelApp();


    return (
        <AssignedTabResource
            useAssignedApp={AssignedShiftResourceApp}
            readOnly={true}
            resource={resource}
            id={id}
            selected={selected}
            setSelected={setSelected}
            selectForDelete={selectForDelete}
            setSelectForDelete={setSelectForDelete}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            triggerDelete={triggerDelete}
            setTriggerDelete={setTriggerDelete}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            results={results}
            setResults={setResults}
            setBodyForExport={setBodyForExport}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            renderModuleTitle={
                <div className='d-flex align-items-center justify-content-start mb-3'>
                    <div><Icon className="mr-8px mb-1" /></div>
                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                        <CustomTooltip
                            text={t(title)}
                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                            showIfTruncated={true}
                        />
                    </div>
                    <div className='vertical-separator-shades-950 h-auto' />
                </div>
            }
        />
    );
};

/**
 * Expanded row detail for a shift access list entry. Renders the shift's
 * assigned devices, departments and custom access (employees) as read-only
 * paginated lists, reusing AssignedTabResource (the same component used in
 * the create/update flow).
 *
 * @param {Object} props
 * @param {Object} props.row - Shift list row ({ id }).
 * @returns {JSX.Element}
 */
const RenderDetails = ({ row }) => {
    return (
        <div className='shift-detail-lists'>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={SHIFT_RESOURCE.DEVICES} id={row.id} title={'assigned_devices'} Icon={AccessDevicesTitle}/>
            </div>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={SHIFT_RESOURCE.DEPARTMENTS} id={row.id} title={'assigned_departments'} Icon={IconChipDepartment}/>
            </div>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={SHIFT_RESOURCE.USERS} id={row.id} title={'assigned_employees'} Icon={IconCustomAccess}/>
            </div>
        </div>
    );
}

export default RenderDetails;
